// extracted by mini-css-extract-plugin
module.exports = {"RedSocial":"RedSocialIcon_RedSocial__CJt60"};